import {priceHelper} from '@helpers/config-master.mjs';
import Link from 'next/link';
import Image from 'next/image';
import {CollectionPageHeaderBannerMobile} from '@components/header/Header';
import {JsonLdBreadcrumbList} from '@components/json-ld/breadcrumb-list';
import {insertMenuItemsBeforeId} from '@components/collections/ManuallyInjectSpecificCollections';

export const MobileCollectionPageComponent = ({slug, title, collections}) => {
  const saleIsEnabled = priceHelper.saleEnabled === true;

  const updatedCollections = insertMenuItemsBeforeId([...collections]);

  return (
    <>
      <CollectionPageHeaderBannerMobile saleIsEnabled={saleIsEnabled} />
      <div className="font-oswald bg-primary rounded pt-3 pb-8 mt-4 px-5 grid grid-cols-2 gap-4">
        {updatedCollections?.map((item, index) => {
          const itemIdIndex = `${item?.id}_${index}`;
          const image = item?.imageUrl;
          const collectionTitle = item?.title ?? item?.sku;
          return (
            image && (
              <Link key={itemIdIndex} href={item?.slug} title={collectionTitle}>
                <div className="rounded-xl overflow-hidden shadow-primary bg-white h-full">
                  {image && collectionTitle && (
                    <Image
                      width={400}
                      height={400}
                      style={{objectFit: 'contain'}}
                      src={image}
                      alt={collectionTitle}
                      sizes="50vw"
                    />
                  )}
                  {collectionTitle && (
                    <h2
                      className="text-xs uppercase font-oswald text-center font-medium py-2 text-black">
                      {collectionTitle} {item?.subtitle ? `(${item?.subtitle})` : ''}
                    </h2>
                  )}
                </div>
              </Link>
            )
          );
        })}
      </div>
      <JsonLdBreadcrumbList handle={'/collections/' + slug} title={title} />
    </>
  );
};
